import React, { useCallback, useMemo } from 'react'
import { useRouter } from '../../../../utils/helper'
import ListPage from '../../../components/templates/ListPage'
import * as paths from '../../../constants/path'
import Button from '../../../components/common/Button'
import Text from '../../../components/common/Text'
import dayjs from 'dayjs'
import { Authorize } from '../../../components/Authorize'
import { ROLE } from '../../../services/user/user-typed'

import { useHistory } from 'react-router-dom'

import { useToastForReactQuery } from '../../../../utils/custom-hooks'
import { appConfig } from '../../../constants/app-config'
import { numberWithCommas } from '../../../../utils/core'
import { ColumnsProps } from '../../../components/common/Table'
import { useGetDcaRecord } from '../../../services/import-dca/import-dca-query'
import { IDcaRecord } from '../../../services/import-dca/import-dca-typed'

const ImportDcaRecordList = () => {
  const { push, query } = useRouter()

  const history = useHistory()
  const { q, page, id } = query

  const onClickViewDetail = useCallback(
    (dcaRecordId: string) => {
      history.push(paths.dcaRecordDetail({ routeParam: { id: dcaRecordId } }))
    },
    [history],
  )

  const columns = useMemo((): ColumnsProps => {
    return [
      { title: 'Tmn Id', dataIndex: 'user.tmnId' },
      {
        title: 'ref',
        dataIndex: 'productRef1',
        render: (v: string) => {
          return (
            <div
              style={{
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-all',
                maxWidth: '150px',
              }}
            >
              {v}
            </div>
          )
        },
      },
      {
        title: 'Amount',
        dataIndex: 'amount',
        render: (v: string, record) => <div>{numberWithCommas(+v, 2)}</div>,
      },
      {
        title: 'type',
        dataIndex: 'type',
      },
      {
        title: 'Create At',
        dataIndex: 'createdAt',
        render: (text: string) => {
          return <Text>{dayjs(text).format('D MMMM  YYYY HH:mm ')}</Text>
        },
      },
      {
        title: 'Status',
        dataIndex: 'status',
        render: (text: string) => {
          //const { isActive } = record
          return <Text>{text}</Text>
        },
      },
      {
        title: '',
        dataIndex: 'action',
        render: (text: string, dcaRecord: IDcaRecord) => {
          return <Button onClick={onClickViewDetail.bind(null, dcaRecord.id)}>View</Button>
        },
      },
    ]
  }, [onClickViewDetail])

  const { data: dcaRecords } = useGetDcaRecord(id, { q, page })

  const setQueryParam = useCallback(
    params => {
      push(paths.dcaRecordList({ routeParam: { id }, queryParam: { ...query, ...params } }))
    },
    [id, push, query],
  )

  const onSearch = useCallback(
    text => {
      setQueryParam({ q: text, page: 1 })
    },
    [setQueryParam],
  )
  const onPageChange = useCallback(
    page => {
      setQueryParam({ page })
    },
    [setQueryParam],
  )

  const toast = useToastForReactQuery()

  return appConfig.ENABLE_FEATURE_IMPORT_DCA ? (
    <Authorize role={ROLE.FINANCE}>
      <ListPage
        topbar={<></>}
        tableProps={{
          columns,
          data: dcaRecords?.items || [],
          onPageChange,
          pagination: dcaRecords?.meta,
        }}
        searchInputProps={{ onSearch, value: query.q, placeholder: 'Search' }}
      />
    </Authorize>
  ) : (
    <></>
  )
}

export default ImportDcaRecordList
